export const weekDaysControlLabelStyles = (selected: boolean) => ({
	position: 'relative',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	padding: '0.25rem',
	cursor: 'pointer',
	width: '2.5rem',
	height: '2.5rem',
	border: '0.0625rem',
	borderStyle: 'solid',
	borderRadius: '0.5rem',
	borderColor: selected ? 'secondary.main' : 'neutrals.primary',
	'&:hover': {
		borderColor: 'secondary.main',
	},
	...(selected && {
		outline: '0.0625rem',
		outlineStyle: 'solid',
		outlineColor: 'secondary.main',
	}),
});

export const checkIconStyles = {
	height: '1rem',
	width: '1rem',
	position: 'absolute',
	color: 'secondary.main',
	top: '0.1rem',
	right: '0.1rem',
};

export const checkboxStyles = {
	'&:hover': {
		backgroundColor: 'transparent',
	},
};
